"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormPeoplePicker = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("@whitbread-eos/utils");
var _server = require("@whitbread-eos/utils/server");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Popover = require("../../Popover");
var _SanitizedContent = require("../../SanitizedContent");
var _Tooltip = require("../../Tooltip");
var _FormInput = require("../FormInput");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var PAGE_SIZE = 20;
var FormPeoplePicker = exports.FormPeoplePicker = React.forwardRef((_ref, ref) => {
  var {
    companyId,
    id,
    value,
    setError,
    onChange = () => {
      return;
    },
    onBlur: _onBlur = () => {
      return;
    },
    onFocus: _onFocus = () => {
      return;
    },
    errors,
    errorIcon,
    inputIcon,
    name,
    placeholder,
    disabled
  } = _ref;
  var {
    t
  } = (0, _server.useTranslation)('users');
  var [employees, setEmployees] = (0, _react.useState)([]);
  var [searchTerm, setSearchTerm] = (0, _react.useState)('');
  var [selectedEmployee, setSelectedEmployee] = (0, _react.useState)(null);
  var [isFocus, setIsFocus] = (0, _react.useState)(false);
  var token = (0, _utils.getAuthCookie)();
  var error = errors === null || errors === void 0 ? void 0 : errors[name];
  var hasError = !!(error !== null && error !== void 0 && error.type);
  var formatEmployee = (title, firstName, lastName, emailAddress) => {
    return "".concat(title, " ").concat(firstName, " ").concat(lastName, " (").concat(emailAddress, ")");
  };
  var getData = (0, _react.useCallback)((0, _debounce.default)((0, _asyncToGenerator2.default)(function* () {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var {
      employees
    } = yield (0, _server.getEmployees)(companyId, PAGE_SIZE, token, 1, search);
    setEmployees(employees.map(employee => {
      return {
        value: employee.id,
        label: formatEmployee(employee.title, employee.firstName, employee.lastName, employee.emailAddress)
      };
    }));
    if (!employees.length) {
      setError(name, {
        type: 'custom',
        message: (0, _jsxRuntime.jsx)("span", {
          children: (0, _jsxRuntime.jsx)(_SanitizedContent.SanitizedContent, {
            replacements: {
              '%searchTerm%': "'".concat(search, "'")
            },
            children: t('userMgmt.manageEmployees.seachresults.noEmployeesFoundErrorMsg')
          })
        })
      });
    }
  }), 300), []);
  var getHighlightedText = (text, highlight) => {
    if (!highlight.trim()) {
      return text;
    }
    var regex = new RegExp("(".concat(highlight, ")"), 'gi');
    return text.split(regex).map((part, index) => part.toLowerCase() === highlight.toLowerCase() ? (0, _jsxRuntime.jsx)("span", {
      className: "font-bold",
      children: part
    }, index) : part);
  };
  (0, _react.useEffect)(() => {
    if (!value || (selectedEmployee === null || selectedEmployee === void 0 ? void 0 : selectedEmployee.value) === value) {
      return;
    }
    var getEmployeeInfo = function () {
      var _ref3 = (0, _asyncToGenerator2.default)(function* () {
        var {
          title,
          firstName,
          lastName,
          emailAddress
        } = yield (0, _server.getEmployeeDetails)(companyId, value, token);
        setSelectedEmployee({
          value,
          label: formatEmployee(title, firstName, lastName, emailAddress)
        });
      });
      return function getEmployeeInfo() {
        return _ref3.apply(this, arguments);
      };
    }();
    getEmployeeInfo();
  }, [value]);
  (0, _react.useEffect)(() => {
    if (searchTerm.length < 3) {
      return;
    }
    getData(searchTerm);
  }, [searchTerm]);
  return (0, _jsxRuntime.jsxs)("div", {
    children: [(0, _jsxRuntime.jsx)(_FormInput.FormInput, {
      id: id,
      name: name,
      value: selectedEmployee ? selectedEmployee.label : searchTerm,
      placeholder: placeholder,
      errors: errors,
      errorIcon: errorIcon,
      showErrorTooltip: false,
      inputIcon: inputIcon,
      disabled: disabled,
      onChange: e => setSearchTerm(e.target.value),
      onFocus: () => {
        setIsFocus(true);
        setEmployees([]);
        setSelectedEmployee(null);
        setSearchTerm('');
        onChange('');
        _onFocus();
      },
      onBlur: () => {
        setIsFocus(false);
        _onBlur();
      },
      ref: ref
    }), (0, _jsxRuntime.jsxs)(_Popover.Popover, {
      open: isFocus,
      children: [(0, _jsxRuntime.jsx)(_Popover.PopoverTrigger, {
        asChild: true,
        children: (0, _jsxRuntime.jsx)("div", {})
      }), (0, _jsxRuntime.jsx)(_Tooltip.ErrorTooltip, {
        icon: errorIcon,
        content: error === null || error === void 0 ? void 0 : error.message,
        open: hasError,
        testId: "".concat(id, "-Error-Tooltip"),
        className: "!flex",
        mobile: true
      }), (0, _jsxRuntime.jsx)(_Popover.PopoverContent, {
        align: "start",
        className: popoverStyle,
        onOpenAutoFocus: e => e.preventDefault(),
        "data-testid": "".concat(id, "-IB-Form-People-Picker-Dropdown"),
        children: employees.map(employee => (0, _jsxRuntime.jsx)("button", {
          "data-testid": "".concat(id, "-IB-Form-People-Picker-Option-").concat(employee.value),
          className: optionStyle,
          onClick: () => {
            setSelectedEmployee(employee);
            setSearchTerm('');
            onChange(employee.value);
          },
          children: (0, _jsxRuntime.jsx)("div", {
            children: getHighlightedText(employee.label, searchTerm)
          })
        }, employee.value))
      })]
    })]
  });
});
FormPeoplePicker.displayName = 'Form People Picker';
var popoverStyle = 'w-full flex flex-col max-h-60 overflow-scroll p-0';
var optionStyle = 'flex w-[--radix-popover-trigger-width] items-center hover:bg-lightGrey5 text-left text-sm py-2.5 px-4 focus-visible:outline-none';